/* unplugin-vue-components disabled */import { render } from "./assign-modal.vue?vue&type=template&id=2e15e8ce&scoped=true"
import script from "./assign-modal.vue?vue&type=script&lang=js"
export * from "./assign-modal.vue?vue&type=script&lang=js"

import "./assign-modal.vue?vue&type=style&index=0&id=2e15e8ce&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e15e8ce"],['__file',"src/pages/tenants/assign-modal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2e15e8ce"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2e15e8ce', __exports__)) {
    api.reload('2e15e8ce', __exports__)
  }
  
  module.hot.accept("./assign-modal.vue?vue&type=template&id=2e15e8ce&scoped=true", () => {
    api.rerender('2e15e8ce', render)
  })

}


export default __exports__